import { styled as o } from "styled-components";
const e = o.div`
  display: flex;
`;
export {
  e as Container
};
